import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { Button } from "@mui/material";
import styled from 'styled-components';

const ProductContainer = styled.div`
	border: 1px solid lightgrey;
	margin-bottom: 8px;
	background-color: white;
	border-radius: 4px;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const ProductItem = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
`;

const IconContainer = styled.div`
	height: 60px;
	display: flex;
	align-items: center;
	margin-right: 6px;
	padding: 0 4px;
`;

const ImageContainer = styled.div`
	margin-right: 8px;
`;

const Image = styled.img`
	width: 35px;
	height: 35px;
	object-fit: contain;
`;

const ProductContent = styled.div`
	display: flex;
	flex-direction: column;
`;
const TitleContainer = styled.div`
	padding: 4px 8px;
	display: flex;
	flex-direction: row;
	align-items: center;
	font-size: 14px;
`;
const SubContentContainer = styled.div`
	padding: 4px 8px;
	display: flex;
	flex-direction: row;
	align-items: center;
	font-size: 11px;
`;

const ActionContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding-right: 8px;
`

const Product = ({ product, index }) => {
	const { title, id, imageUrl, price, currency } = product;

	return (
		<Draggable draggableId={id} index={index} key={id}>
			{(provided, snapshot) => (
				<ProductContainer
					{...provided.draggableProps}
					{...provided.dragHandleProps}
					ref={provided.innerRef}
				>
					<ProductItem>
						<IconContainer>
							<DragIndicatorIcon fontSize="small" sx={{ color: '#666666' }} />
						</IconContainer>
						<ImageContainer>
							<Image
								src={imageUrl}
								alt={title}
								onError={({ currentTarget }) => {
									currentTarget.onerror = null; // prevents looping
									currentTarget.src = 'https://via.placeholder.com/300x300';
								}}
							/>
						</ImageContainer>
						<ProductContent>
							<TitleContainer>
								<span>{title}</span>
							</TitleContainer>
							<SubContentContainer>
								{currency} {product.flashSaleInfo ? product.flashSaleInfo.price : price}
							</SubContentContainer>
						</ProductContent>						
					</ProductItem>
				</ProductContainer>
				
			)}
		</Draggable>
	);
};

export default Product;
